/* AB ab_flex_offer — sunsets 2026-10-31, delete src/pages/AB_FlexOfferSuivi/ */

import { getAgentDetailsFromEtsToken } from '../../resources/login/operations';

import { AB_FLEX_OFFER_ALLOWLIST_AGENCY_IDS } from './AB_allowlistAgencyIds';

export const AB_FLEX_OFFER_SUIVI_PATH = '/flex-offer-suivi';

export function useAB_FlexOfferEligible(): boolean {
    const agentDetails = getAgentDetailsFromEtsToken();
    const agencyId = agentDetails?.agencyId;
    if (typeof agencyId !== 'number') {
        return false;
    }
    return AB_FLEX_OFFER_ALLOWLIST_AGENCY_IDS.has(agencyId);
}
